import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type { TrackQuery, TrackReportRequest, TrackReportResult, TrackRow } from '../types/track';

const BASE = '/wl/track';

/** 配送轨迹（Hq.Api Tracking）：只读时间轴 + 节点回传（PICK/PACK/SHIP/ARRIVE/EXCEPTION）。 */
export function createTrackApi(http: HttpClient) {
  return {
    list(query: TrackQuery = {}): Promise<PageResult<TrackRow>> {
      return http.request<PageResult<TrackRow>>({ path: BASE, query: toQuery(query) });
    },

    /** 回传节点：需 `wl:delivery:manage` 或 `wl:inventory:manage`（PDA/移动端回传用）。 */
    report(body: TrackReportRequest): Promise<TrackReportResult> {
      return http.request<TrackReportResult>({ path: BASE, method: 'POST', body });
    }
  };
}

export type TrackApi = ReturnType<typeof createTrackApi>;
